import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import { Card, Grid, Pagination, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import Select from "../../../../components/Select/Select";
import {
  addDirectBilling,
  getPetBillingById,
  getPetBulkBillingByIdAllWoLoader,
  updateMultiplePayment,
} from "../../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../../util/AppColors";
import {
  billAsForBillingHistory,
  billingFilters,
  paymentStatusList,
  PaymentTypeList,
  RMVPaymentTypeList,
} from "../../../../util/dropList";
import {
  getBorderColor,
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getRightSaluation,
  getSelectedInvoicesBalanceDue,
  getTaxAndSubTotalAndTotal,
  getTaxAndSubTotalAndTotalForTreatment,
  getTreatmentRecordBasedType,
  roundWithSignedDiff,
} from "../../../../util/function";
import { RMVClinicId } from "../../../../util/server";
import PaymentModeDropdown from "../../../CommonComponents/PaymentModeDropdown";
import BillingPreview from "../../../CommonScreens/BillingPreview/BillingPreview";
import Billing from "./Billing";

const initialValues = { amount: "", paymentMode: null };
const initSearch = {
  invoiceNumber: "",
  status: [],
  appointmentType: [],
  doctorName: "",
};
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const filterByList = [
  "Date",
  // "Person In Charge"
];

const BillingHistory = ({
  isEditBill,
  setEditBill,
  petId,
  selectedBill,
  setSelectedBill,
  apntId,
}) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [invModVisible, setInvModVisible] = useState(false);
  const [payValues, setPayValues] = useState(initialValues);
  const [payErr, setPayErr] = useState({});
  const [modalData, setModalData] = useState();
  const [payModalVisible, setPayModalVisible] = useState(false);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [filterValues, setFilterValues] = useState(initFilter);
  const [enabledPaymentTypes, setEnabledPaymentTypes] =
    useState(PaymentTypeList);
  const [totalBalanceDue, setTotalBalanceDue] = useState(0);
  const [billingList, setBillingList] = useState([]);
  const [refereneValues, setRefereneValues] = useState({
    visible: false,
    referenceNo: null,
    billAs: "Pharmacy",
  });
  const {
    petBilling,
    petBulkBilling,
    services,
    clinicStocks: stocks,
    details: clinicDet,
  } = useSelector((state) => state?.clinic);
  const petData = useSelector(
    (state) => state?.pet?.complaintSummary?.data?.pet,
  );
  const lastSummary = useSelector((state) => state?.pet?.lastSummary?.data);
  const petDetails = useSelector((state) => state?.pet?.petDetails);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const itemsPerLoad = 10;
  const defaultUrl = `?page=1&itemSize=${itemsPerLoad}`;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const petDet = apntId ? petData : petDetails;
  const statusActive =
    typeof petDet?.status === "boolean"
      ? petDet?.status
      : petDet?.status === "Y";

  useEffect(() => {
    if (!isEditBill && !selectedBill) {
      onApiCall(1, true);
      dispatch(getPetBulkBillingByIdAllWoLoader({ petId }));
      // dispatch(getClinicStocks());
      // dispatch(getServices());
    }
    if (isEditBill) {
      onReset();
    }
  }, [isEditBill, selectedBill]);

  useEffect(() => {
    if (!isEditBill && !selectedBill) {
      onApiCall();
    }
  }, [
    searchValues?.invoiceNumber,
    searchValues?.status,
    searchValues?.appointmentType,
    searchValues?.doctorName,
    isEditBill,
    selectedBill,
  ]);

  useEffect(() => {
    const reqList = (petBilling?.data ?? [])?.map((li, i) => ({
      ...li,
      i,
      isSelected: false,
    }));
    setBillingList(reqList);
  }, [petBilling?.data]);

  const getFilterObj = (currentPage = 1, reset = false) => {
    setPage(currentPage);
    const reqObj = { page: currentPage, itemSize: itemsPerLoad };
    if (reset) return reqObj;
    if (searchValues?.invoiceNumber?.length > 0)
      reqObj.invoiceNumber = searchValues?.invoiceNumber;
    if (searchValues?.status?.length > 0) {
      reqObj.status = searchValues?.status?.some(
        (li) => li?.value?.toLowerCase() === "all",
      )
        ? ["paid", "unpaid", "ppaid", "partiallypaid"]
        : searchValues?.status?.map((li) => li?.value);
    }
    if (searchValues?.appointmentType?.length > 0) {
      reqObj.appointmentType = searchValues?.appointmentType?.some(
        (li) => li?.value?.toLowerCase() === "all",
      )
        ? ["Home", "Physical", "Virtual"]
        : searchValues?.appointmentType?.map((li) => li?.value);
    }
    if (searchValues?.doctorName?.length > 0)
      reqObj.doctorName = searchValues?.doctorName;

    if (filterValues?.selectedList?.includes("Date")) {
      if (filterValues?.values?.["Start Date"]) {
        reqObj.startDate = moment(
          new Date(filterValues?.values?.["Start Date"]),
        ).format("YYYY-MM-DD");
      }
      if (
        filterValues?.values?.["End Date"] ||
        filterValues?.values?.["Start Date"]
      ) {
        reqObj.endDate = moment(
          new Date(
            filterValues?.values?.["End Date"] ??
              filterValues?.values?.["Start Date"],
          ),
        ).format("YYYY-MM-DD");
      }
    }
    if (
      filterValues?.selectedList?.includes("Person In Charge") &&
      filterValues?.values?.["Person In Charge"]
    ) {
      reqObj.personInCharge = filterValues?.values?.["Person In Charge"];
    }
    return reqObj;
  };

  const onApiCall = (currentPage = 1, reset = false) => {
    dispatch(
      getPetBillingById({
        petId,
        data: getFilterObj(currentPage, reset),
      }),
    );
  };

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const handleInvModClose = () => {
    setSelectedBill(null);
    setInvModVisible(false);
  };

  const handleChangeValues = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const reqObj = { ...payValues, [name]: value };
    setPayValues(reqObj);
    const errObj = {
      ...payErr,
      [name]: reqValue?.length > 0 ? "" : "This field is required",
    };
    if (name === "paymentMode") {
      if (reqValue !== "advanceAdjustment") {
        errObj.amount = "";
      }
      if (reqValue === "advanceAdjustment") {
        if (Number(billingList?.[0]?.advanceAmount ?? 0) <= 0) {
          errObj.amount = "Insufficient credit balance";
        }
      }
    }
    if (name === "amount") {
      if (payValues?.paymentMode?.value === "advanceAdjustment") {
        errObj.amount =
          Number(value) < 0
            ? "Amount must be positive"
            : Number(value) > Number(billingList?.[0]?.advanceAmount ?? 0)
              ? "Insufficient credit balance"
              : "";
      } else {
        errObj.amount = Number(value) < 0 ? "Amount must be positive" : "";
      }
      if (Number(value) > totalBalanceDue) {
        errObj.amount = "Amount must be less than or equal to balance due";
      }
    }
    setPayErr(errObj);
  };

  const payModalClose = (li) => {
    setModalData(li);
    setPayValues(initialValues);
    setPayModalVisible(false);
    setPayErr({});
  };

  const getBatch = (stkId = null, batchId = null) => {
    if (!stkId || !batchId) return null;
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stkId);
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const finalPayment = () => {
    //validation start
    let errs = {};
    if (
      !payValues?.amount ||
      isNaN(Number(payValues?.amount)) ||
      Number(payValues?.amount) <= 0 ||
      Number(payValues?.amount) > totalBalanceDue ||
      (payValues?.paymentMode?.value === "advanceAdjustment" &&
        Number(payValues?.amount) >
          Number(billingList?.[0]?.advanceAmount ?? 0))
    ) {
      errs = {
        ...errs,
        amount:
          payValues?.paymentMode?.value === "advanceAdjustment" &&
          Number(payValues?.amount) >
            Number(billingList?.[0]?.advanceAmount ?? 0)
            ? "Insufficient credit balance"
            : !payValues?.amount
              ? "This field is required"
              : Number(payValues?.amount) > totalBalanceDue
                ? "Amount must be less than or equal to balance due"
                : Number(payValues?.amount) <= 0
                  ? "Amount must be positive"
                  : "",
      };
    }
    if (!payValues?.paymentMode?.value) {
      errs = { ...errs, paymentMode: "This field is required" };
    }
    if (Object.values(errs).some((item) => item?.length > 0)) {
      return setPayErr(errs);
    }
    if (billingList?.filter((bil) => bil?.isSelected)?.length === 0) return;
    //validation end here
    const multiplePayments = billingList
      ?.filter((bil) => bil?.isSelected)
      ?.map((bil) => ({ paymentId: bil?.paymentId }))
      ?.sort((a, b) => a?.paymentId - b?.paymentId);
    dispatch(
      updateMultiplePayment({
        multiplePayments,
        amount: Number(payValues?.amount),
        mode: payValues?.paymentMode?.value,
      }),
    ).then((res) => {
      if (res?.payload) {
        onApiCall();
        setPayModalVisible(false);
        setPayValues(initialValues);
        setTotalBalanceDue(0);
        setPayErr({});
      }
    });
  };

  const handleCheckItem = (value, ind) => {
    const reqList = billingList?.map((bill, i) => {
      if (i === ind) return { ...bill, isSelected: value };
      return bill;
    });
    setBillingList(reqList);
  };

  const handlePayDownload = () => {
    if (billingList?.some((bl) => bl?.isSelected)) {
      const dueAmount = getSelectedInvoicesBalanceDue(
        billingList?.filter((bil) => bil?.isSelected),
        Number(0),
        services?.data,
        selectedBill?.procedure ?? [],
      );
      setPayValues({
        ...payValues,
        amount: dueAmount,
      });
      setTotalBalanceDue(dueAmount);
      if (
        billingList?.[0]?.advanceAmount &&
        Number(billingList?.[0]?.advanceAmount) <= 0
      ) {
        const filtered = PaymentTypeList.filter(
          (list) => list?.value !== "advanceAdjustment",
        );
        setEnabledPaymentTypes(filtered);
      } else {
        setEnabledPaymentTypes(PaymentTypeList);
      }
      setPayModalVisible(true);
    }
  };

  const getReferenceNos = () => {
    const list = [];
    billingList?.forEach((bl) => {
      if (bl?.invoiceNumbers?.length > 0) {
        list.push({
          name: bl?.invoiceNumbers,
          value: bl?.invoiceNumbers,
        });
      }
      if (bl?.treatmentInvoiceNumber?.length > 0) {
        list.push({
          name: bl?.treatmentInvoiceNumber,
          value: bl?.treatmentInvoiceNumber,
        });
      }
      if (bl?.petShopInvoiceNumber?.length > 0) {
        list.push({
          name: bl?.petShopInvoiceNumber,
          value: bl?.petShopInvoiceNumber,
        });
      }
    });
    return list;
  };

  const handleCreateBill = (isCreate = false) => {
    if (!isCreate && billingList?.length > 0 && getReferenceNos()?.length > 0) {
      setRefereneValues({
        visible: true,
        referenceNo: null,
        billAs: "Pharmacy",
      });
      return;
    }
    const data = {
      userId: petDet?.userId,
      type: refereneValues?.billAs,
      // type: "Clinic",
      paymentOption: "",
      direct: [],
      discountValue: 0,
      discountType: "percentage",
      petId: petDet?.petId,
      referenceNo: refereneValues?.referenceNo?.value ?? "",
    };
    dispatch(addDirectBilling(data)).then((res) => {
      if (res?.payload) {
        setSelectedBill({ paymentId: res?.payload?.data });
        setEditBill(true);
        setRefereneValues({ visible: false, referenceNo: null });
      }
    });
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    setSearchValues({
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    });
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({ ...initFilter, selectedList: [], values: {} });
    });
    onApiCall(1, true);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = {
      ...initFilter,
      visible: true,
      selectedList: [],
      values: {},
    };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const getInvoices = () => {
    const reqList = (petBulkBilling?.data ?? [])
      ?.flatMap((li) => [
        li?.invoiceNumbers ?? "",
        li?.petShopInvoiceNumber ?? "",
        li?.treatmentInvoiceNumber ?? "",
      ])
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getVetNames = () => {
    const reqList = (petBulkBilling?.data ?? [])
      ?.map((li) => li?.doctorName ?? "")
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  return (
    <>
      {isEditBill ? (
        <Billing bill={selectedBill} />
      ) : (
        <div className="w100Per mt20">
          <Grid container className="back-white">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="ph20">
              <div className="flex-row-ali-cen">
                <div className="top-row-cen-con w100Per">
                  <div className="w15Per">
                    <CustomTextField
                      placeholder="Invoice Number"
                      fullWidth
                      name="invoiceNumber"
                      handleChange={onSearchChange}
                      value={searchValues?.invoiceNumber}
                      backgroundColor={AppColors.lightBlue2}
                      label="Invoice Number"
                      suggetions
                      options={getInvoices()}
                    />
                  </div>
                  <div className="w15Per ml15">
                    <Select
                      list={paymentStatusList}
                      value={searchValues?.status}
                      handleChange={onSearchChange}
                      name="status"
                      label="Payment Status"
                      multiSelectSearchCheck
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>
                  <div className="w15Per ml15">
                    <Select
                      list={billingFilters}
                      value={searchValues?.appointmentType}
                      handleChange={onSearchChange}
                      name="appointmentType"
                      label="Consultation Type"
                      multiSelectSearchCheck
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>
                  <div className="w15Per ml15">
                    <CustomTextField
                      placeholder="Vet Name"
                      fullWidth
                      name="doctorName"
                      handleChange={onSearchChange}
                      value={searchValues?.doctorName}
                      backgroundColor={AppColors.lightBlue2}
                      label="Vet Name"
                      suggetions
                      options={getVetNames()}
                    />
                  </div>
                  <div
                    className="flex-row-ali-cen ml15 filter cursor"
                    onClick={() => onFilterChange("visible", true)}
                  >
                    <TuneIcon sx={{ color: AppColors.appPrimary }} />
                    <Typography className="font-medium fs12 blue-color ml10">
                      {filterValues?.selectedList?.length > 0
                        ? `${filterValues?.selectedList?.length} `
                        : ""}
                      Filter
                    </Typography>
                  </div>
                  <div className="ml15">
                    <CustomButton
                      text="Reset"
                      onClick={onReset}
                      smallBtn
                      redBtn
                    />
                  </div>
                  <div className="ml15">
                    <CustomButton
                      text="Create bill"
                      smallBtn
                      onClick={() => handleCreateBill(false)}
                    />
                  </div>
                  {billingList?.some((bl) => bl?.isSelected) ? (
                    <div className="ml15">
                      <CustomButton
                        text="Pay"
                        smallBtn
                        onClick={handlePayDownload}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="flex-center">
                <div className="pb100 w90Per scroll-70vh ph10 mt10">
                  {billingList?.length > 0 ? (
                    billingList?.map((bill, ind) => (
                      <div className="flex-row-ali-cen mv10" key={ind + "bill"}>
                        <div className="w5Per">
                          <CustomCheckbox
                            checked={bill?.isSelected}
                            onChange={(e) => handleCheckItem(!e, ind)}
                            disabled={bill?.status === "paid"}
                          />
                        </div>
                        <div
                          className="w95Per bil-brdr cursor"
                          onClick={() => {
                            if (
                              bill?.appointmentStatus === "completed" ||
                              // bill?.status === "paid" ||
                              !statusActive
                            ) {
                              // dispatch(
                              //   getCompliantSummaryByIdWoLoader(
                              //     bill?.appointmentId,
                              //   ),
                              // );
                              setSelectedBill(bill);
                              return setInvModVisible(true);
                            }
                            if (
                              bill?.appointmentStatus !== "completed"
                              //  && bill?.status !== "paid"
                            ) {
                              setSelectedBill(bill);
                              return setEditBill(true);
                            }
                          }}
                        >
                          <div className="flex-row-ali-cen">
                            <div className="w10Per">
                              <div className="flex-column">
                                <Typography className="blue-color txt-semi-bold fs36 flex-center mb10Min">
                                  {moment(new Date(bill?.createdDate)).format(
                                    "DD",
                                  )}
                                </Typography>
                                <Typography className="blue-color txt-semi-bold fs12 flex-center">
                                  {moment(new Date(bill?.createdDate)).format(
                                    "MMM YYYY",
                                  )}
                                </Typography>
                                <div className="flex-center mt5">
                                  <div className="bil-yel-line w100Per" />
                                </div>
                              </div>
                            </div>
                            <div className="w60Per ph10">
                              <div className="flex-column">
                                <Typography className="txt-semi-bold fs14 black21">
                                  {bill?.invoiceNumbers ??
                                    bill?.treatmentInvoiceNumber}
                                </Typography>
                                <Typography className="txt-semi-bold fs14 gray27 capitalize mt5">
                                  {getRightSaluation(
                                    clinicVets,
                                    bill?.doctorId,
                                  )}
                                  {/* {bill?.doctorId === bill?.clinicId
                                    ? ""
                                    : "Dr. "} */}
                                  {bill?.doctorName}
                                </Typography>
                              </div>
                            </div>
                            <div className="w30Per">
                              <div className="flex-end">
                                <div className="flex-column">
                                  <div className="flex-end">
                                    <Typography className="fs14 font-bold blue-color">
                                      Rs.{" "}
                                      {Number(
                                        Number(
                                          roundWithSignedDiff(
                                            getTaxAndSubTotalAndTotalForTreatment(
                                              getTreatmentRecordBasedType(
                                                bill?.paymentDetails,
                                              ),
                                              services?.data,
                                              bill?.procedure ?? [],
                                            )?.subTotal,
                                          )?.rounded +
                                            roundWithSignedDiff(
                                              getTaxAndSubTotalAndTotal(
                                                getPharmacyRecordBasedType(
                                                  bill?.paymentDetails,
                                                ),
                                              )?.subTotal,
                                            )?.rounded +
                                            roundWithSignedDiff(
                                              getTaxAndSubTotalAndTotal(
                                                getPetShopRecordBasedType(
                                                  bill?.paymentDetails,
                                                ),
                                              )?.subTotal,
                                            )?.rounded,
                                        ) -
                                          Number(
                                            Number(bill?.amtPaid ?? 0) +
                                              Number(
                                                bill?.pharmacyAmtPaid ?? 0,
                                              ) +
                                              Number(bill?.petShopAmtPaid ?? 0),
                                          ),
                                      ) > 0
                                        ? Number(
                                            Number(
                                              roundWithSignedDiff(
                                                getTaxAndSubTotalAndTotalForTreatment(
                                                  getTreatmentRecordBasedType(
                                                    bill?.paymentDetails,
                                                  ),
                                                  services?.data,
                                                  bill?.procedure ?? [],
                                                )?.subTotal,
                                              )?.rounded +
                                                roundWithSignedDiff(
                                                  getTaxAndSubTotalAndTotal(
                                                    getPharmacyRecordBasedType(
                                                      bill?.paymentDetails,
                                                    ),
                                                  )?.subTotal,
                                                )?.rounded +
                                                roundWithSignedDiff(
                                                  getTaxAndSubTotalAndTotal(
                                                    getPetShopRecordBasedType(
                                                      bill?.paymentDetails,
                                                    ),
                                                  )?.subTotal,
                                                )?.rounded,
                                            ) -
                                              Number(
                                                Number(bill?.amtPaid ?? 0) +
                                                  Number(
                                                    bill?.pharmacyAmtPaid ?? 0,
                                                  ) +
                                                  Number(
                                                    bill?.petShopAmtPaid ?? 0,
                                                  ),
                                              ),
                                          )?.toFixed(2)
                                        : "Nil"}
                                    </Typography>
                                  </div>
                                  <div className="flex-row-ali-cen mt10">
                                    <div className="flex1-end">
                                      {bill?.appointmentType ? (
                                        <Typography
                                          className={`br5 ph10 pv5 font-medium  fs12 white-color ${
                                            bill?.appointmentType === "Physical"
                                              ? "card-con-blue-back"
                                              : "virtual-bg-color"
                                          }`}
                                        >
                                          {bill?.appointmentType === "Home"
                                            ? "Home Visit"
                                            : bill?.appointmentType}
                                        </Typography>
                                      ) : null}

                                      <Typography
                                        className={`font-medium fs12 br5 ph10 pv5 ml10 ${
                                          bill?.status === "paid"
                                            ? "green2 green-back2"
                                            : bill?.status === "partiallypaid"
                                              ? "yellow3 yel-back"
                                              : "red13 red-back3"
                                        }`}
                                      >
                                        {bill?.status === "paid"
                                          ? "Paid"
                                          : bill?.status === "partiallypaid"
                                            ? "Partially Paid"
                                            : "Unpaid"}
                                      </Typography>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="no-rec">No records available</div>
                  )}
                  {Math.ceil(petBilling?.totalRecords / itemsPerLoad) > 1 ? (
                    <div className="flex-end">
                      <Pagination
                        count={Math.ceil(
                          petBilling?.totalRecords / itemsPerLoad,
                        )}
                        variant="outlined"
                        color="primary"
                        page={page}
                        onChange={handleChangePage}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      )}
      {invModVisible ? (
        <BillingPreview
          selectedBill={selectedBill}
          modVsble={invModVisible}
          onClosePreview={handleInvModClose}
          billsToShow={["treatment", "pharmacy", "petshop"]}
        />
      ) : null}
      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        {li === "Person In Charge" ? null : (
                          // <Select
                          //   list={[
                          //     {
                          //       name: clinicDet?.name,
                          //       value: clinicDet?.id,
                          //     },
                          //   ]}
                          //   value={filterValues?.values?.[li]}
                          //   name={li}
                          //   handleChange={onFilterValuesChange}
                          //   label={li}
                          //   select
                          // />
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="Start Date"
                                fullWidth
                                name="Start Date"
                                handleChange={onFilterValuesChange}
                                value={filterValues?.values?.["Start Date"]}
                                label="Start Date"
                                mobileDate
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="End Date"
                                fullWidth
                                name="End Date"
                                handleChange={onFilterValuesChange}
                                value={filterValues?.values?.["End Date"]}
                                label="End Date"
                                mobileDate
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
      <CustomModal
        open={payModalVisible}
        onClose={payModalClose}
        header="Pay"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh">
          <div className="flex-center">
            <Card
              sx={{
                borderRadius: 1,
                padding: 2,
                borderTopColor: `${getBorderColor(
                  modalData?.status ?? "unpaid",
                )}`,
              }}
              className="pay-card"
            >
              <div className="flex-row">
                <div className="w50Per">
                  <Typography className="fs12 txt-semi-bold gray14">
                    Pet Name
                  </Typography>
                  <Typography className="fs14 txt-semi-bold black">
                    {billingList?.[0]?.petName}
                  </Typography>
                </div>
                <div className="w50Per">
                  <Typography className="fs12 txt-semi-bold gray14">
                    Parent Name
                  </Typography>
                  <Typography className="fs14 txt-semi-bold black">
                    {billingList?.[0]?.userName}
                  </Typography>
                </div>
              </div>
              <div className="mh20Min">
                <div className="gry-hor-split3 mv5" />
              </div>
              {billingList
                ?.filter((bil) => bil?.isSelected)
                ?.map((li) => (
                  <div className="mt10" key={li?.paymentId + "invit"}>
                    <Typography className="txt-regular fs14 gray7">
                      {moment(new Date(li?.createdDate)).format("DD MMM, YYYY")}
                    </Typography>
                    <div className="bil-his-box mt5">
                      <div className="flex-row">
                        <div className="flex-start">
                          <Typography className="fs14 font-medium black">
                            {li?.invoiceNumbers}
                          </Typography>
                        </div>
                        <div className="flex1-end">
                          <Typography className="txt-semi-bold fs14 orange3">
                            {Number(
                              Number(
                                roundWithSignedDiff(
                                  getTaxAndSubTotalAndTotalForTreatment(
                                    getTreatmentRecordBasedType(
                                      li?.paymentDetails,
                                    ),
                                    services?.data,
                                    li?.procedure ?? [],
                                  )?.subTotal,
                                )?.rounded +
                                  roundWithSignedDiff(
                                    getTaxAndSubTotalAndTotal(
                                      getPharmacyRecordBasedType(
                                        li?.paymentDetails,
                                      ),
                                    )?.subTotal,
                                  )?.rounded +
                                  roundWithSignedDiff(
                                    getTaxAndSubTotalAndTotal(
                                      getPetShopRecordBasedType(
                                        li?.paymentDetails,
                                      ),
                                    )?.subTotal,
                                  )?.rounded,
                              ) - Number(li?.amtPaid ?? 0),
                            ) > 0
                              ? `Rs ${Number(
                                  Number(
                                    roundWithSignedDiff(
                                      getTaxAndSubTotalAndTotalForTreatment(
                                        getTreatmentRecordBasedType(
                                          li?.paymentDetails,
                                        ),
                                        services?.data,
                                        li?.procedure ?? [],
                                      )?.subTotal,
                                    )?.rounded +
                                      roundWithSignedDiff(
                                        getTaxAndSubTotalAndTotal(
                                          getPharmacyRecordBasedType(
                                            li?.paymentDetails,
                                          ),
                                        )?.subTotal,
                                      )?.rounded +
                                      roundWithSignedDiff(
                                        getTaxAndSubTotalAndTotal(
                                          getPetShopRecordBasedType(
                                            li?.paymentDetails,
                                          ),
                                        )?.subTotal,
                                      )?.rounded,
                                  ) - Number(li?.amtPaid ?? 0),
                                )?.toFixed(2)}`
                              : "Nil"}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              <div className="mt20 bil-bal-con">
                <div className="flex-row">
                  <div>
                    <Typography className="font-bold fs14 red-color">
                      Balance Due
                    </Typography>
                  </div>
                  <div className="flex1-end">
                    <Typography className="font-bold fs14 red-color">
                      Rs{" "}
                      {getSelectedInvoicesBalanceDue(
                        billingList?.filter((bil) => bil?.isSelected),
                        Number(0),
                        services?.data,
                        selectedBill?.procedure ?? [],
                      )?.toFixed(2)}
                    </Typography>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <CustomTextField
                label="Amount"
                name="amount"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("amount", e?.target?.value)
                }
                value={payValues?.amount}
                labelTop
                helperText={payErr?.amount}
                error={!!payErr?.amount}
                type="number"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="font-medium fs14 black2">Payment Mode</div>
              <PaymentModeDropdown
                list={
                  (profile?.id || profile?.createdBy) === RMVClinicId
                    ? RMVPaymentTypeList
                    : enabledPaymentTypes
                }
                value={payValues?.paymentMode}
                error={!!payErr?.paymentMode}
                helperText={payErr?.paymentMode}
                onChange={(e, value) => {
                  handleChangeValues("paymentMode", e);
                }}
                name="paymentMode"
                label=""
              />
              {/* <Select
                list={
                  (profile?.id || profile?.createdBy) === RMVClinicId
                    ? RMVPaymentTypeList
                    : enabledPaymentTypes
                }
                value={payValues?.paymentMode}
                handleChange={(e, value) =>
                  handleChangeValues("paymentMode", value)
                }
                name="paymentMode"
                search
                helperText={payErr?.paymentMode}
                error={!!payErr?.paymentMode}
              /> */}
            </Grid>
            {payValues?.paymentMode?.value === "advanceAdjustment" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="txt-semi-bold fs14 orange5">
                  Available Balance:{" "}
                  {Number(billingList?.[0]?.advanceAmount) > 0
                    ? Number(billingList?.[0]?.advanceAmount)?.toFixed(2)
                    : "-"}
                </Typography>
              </Grid>
            ) : null}

            <div className="flex1-end mt20">
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <CustomButton text="Pay" onClick={finalPayment} smallBtn />
              </Grid>
            </div>
          </Grid>
        </div>
      </CustomModal>
      <CustomModal
        open={refereneValues?.visible}
        onClose={() => setRefereneValues({ visible: false, referenceNo: null })}
        header="Create Bill"
        // header="Select Reference No"
        modal
        modalWidth={25}
      >
        <div className="ph20 pb20">
          <div className="font-medium fs14 black2">Bill as</div>
          <Select
            list={billAsForBillingHistory}
            value={refereneValues?.billAs}
            handleChange={(e) => {
              setRefereneValues({
                ...refereneValues,
                billAs: e?.target?.value,
              });
            }}
            select
            // search
          />
          {/* <div className="font-medium fs14 black2">Reference No</div>
          <Select
            list={getReferenceNos()}
            value={refereneValues?.referenceNo}
            handleChange={(e, value) => {
              setRefereneValues({ ...refereneValues, referenceNo: value });
            }}
            search
          /> */}
          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Submit"
                onClick={() => handleCreateBill(true)}
                smallBtn
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default BillingHistory;
